import { ProjectStopsScheduledDtoModelType } from '../../models/ProjectStopsScheduledDtoModel';
import { assignStopsSuccessNotification } from '../../../../notifications/scheduling/assignStops';
import getAppEnv from '../../utils/getAppEnv';
import { SolutionActionStatus } from '../../../../constants';

export default ({ store, pendingSolution }: ProjectStopsScheduledDtoModelType) => {
  const appEnv = getAppEnv(store);
  const action = pendingSolution.assignAction;
  const status = pendingSolution.solutionStatus?.name;

  if (action && status) {
    const visitCount = action.details?.eventUuids?.length;

    if (status === SolutionActionStatus.COMPLETED && visitCount) {
      appEnv.notification(assignStopsSuccessNotification(pendingSolution.id, visitCount));
    }
  }

  return () => {
    store.assignActionStatusDtos.delete(pendingSolution.assignAction.id);
    store.solutionStatusOnlyDtos.delete(pendingSolution.id);
  };
};
